import React, { useState } from "react"
import { Alert, Button, FormControlLabel, Radio, RadioGroup } from "@mui/material"
import Servo from "../../services/servo"
import "./CierreOrden.css"

export const estadosTerminados = ["FINALIZADO", "TERMINADA_TECNICAMENTE", "EN_REVISION_SALIDA", "LISTA_PARA_ENTREGA", "ENTREGADA", "CERRADA"]

export default function CierreOrden({ orden, permiso, onSaved }) {
  const [resultado, setResultado] = useState("")
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState("")
  const terminada = estadosTerminados.includes(orden.status)
  const registrado = orden.mantenimientoPreventivo
  const confirmadoSin = orden.fechaValidacionPreventivo && !orden.cumpleMantenimientoPreventivo
  const restringido = ["mecanico", "almacen", "jac"].includes(permiso?.rol?.trim().toLowerCase())
  const puedeCerrar = !restringido && (permiso?.ordenServicios & 4) === 4
  const puedePreventivo = puedeCerrar && (permiso?.proximoServicio & 4) === 4
  const km = orden.kilometrajeTerminacion || orden.checklists?.gasolinachecklists?.kilometraje
  const guardar = async () => {
    setBusy(true); setError("")
    try {
      const res = await Servo.post("orden-servicios/finalizar-orden-servicio", {
        idOrdenServicio: orden.idOrdenServicio,
        preventivoCompleto: resultado === "si",
        confirmarPreventivoIncompleto: resultado === "no",
        confirmacionSimple: true
      }, "ordenServicios", false)
      if (res?.cuerpo?.detalle?.estatus !== 200) {
        setError(res?.cuerpo?.mensaje || "No se pudo guardar la confirmación.")
        return
      }
      await onSaved()
    } catch (e) { setError("No se pudo confirmar la respuesta. Consulta la orden antes de reintentar.") }
    finally { setBusy(false) }
  }
  if (!orden.idOrdenServicio) return null
  return <section className="order-closure">
    <div className="order-closure__panel">
      <h2>Finalizar orden de servicio</h2>
      {registrado ? <Alert severity="success">Preventivo realizado. Próximo servicio: {registrado.proximoKilometraje ? registrado.proximoKilometraje + " km" : "sin intervalo por km"}{registrado.proximaFecha ? " · " + registrado.proximaFecha : ""}.</Alert>
        : confirmadoSin ? <Alert severity="success">Se confirmó que no se realizó el preventivo. El próximo servicio conserva su vencimiento anterior.</Alert>
        : orden.status === "CANCELADA" ? <Alert severity="info">Esta orden está cancelada.</Alert>
        : !puedeCerrar ? <Alert severity="info">No tienes permiso para finalizar esta orden.</Alert>
        : <>
          <p>{terminada ? "La orden ya está terminada. Solo falta confirmar el mantenimiento realizado." : "Confirma el mantenimiento realizado para finalizar esta orden."}</p>
          <h3 id="preventivo-pregunta">¿Se realizó el mantenimiento preventivo completo?</h3>
          <RadioGroup row aria-labelledby="preventivo-pregunta" value={resultado} onChange={e => { setResultado(e.target.value); setError("") }}>
            <FormControlLabel value="si" control={<Radio />} label="Sí" disabled={busy || !puedePreventivo} />
            <FormControlLabel value="no" control={<Radio />} label="No" disabled={busy} />
          </RadioGroup>
          {resultado === "si" && <p className="order-closure__hint">Se actualizará el próximo servicio con el kilometraje registrado{km ? ": " + km + " km" : " (falta capturarlo en el checklist)"}.</p>}
          {resultado === "no" && <p className="order-closure__hint">El próximo servicio conservará su vencimiento anterior.</p>}
          {!puedePreventivo && <p className="order-closure__hint">Para confirmar “Sí” necesitas permiso de edición de Próximos servicios.</p>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Button variant="contained" disabled={busy || !resultado || (resultado === "si" && !puedePreventivo)} onClick={guardar}>{busy ? "Guardando…" : terminada ? "Confirmar mantenimiento" : "Finalizar orden"}</Button>
        </>}
    </div>
  </section>
}
